// @core/api/endpoints/form/delete_form_field.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/form';

/**
 * Delete form field
 * Deletes a form field. Associated submission answers are preserved but orphaned.
 */
export async function DeleteFormField(
  field_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/fields/:field_id`;
  requestPath = requestPath.replace(':field_id', encodeURIComponent(field_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
